<template>
  <v-container class="booking-preview p-0" v-if="invoice" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="require('@/assets/acc.jpg')"
                         :label="$t('invoice.summary')"
                         :is-snap-content="true">
      <v-row class="booking-preview-content-row mb-3 py-3">
        <v-col>
          <v-form class="booking-preview-form text-left">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field readonly
                                hide-details
                                :label="$t('admin_acc_invoice.invoice_no')"
                                :value="`PO${invoice.purchase_order.id.toString().padStart(8, '0')}/${invoice.invoice_no}`"></v-text-field>
                  <v-text-field readonly
                                hide-details
                                :label="$t('admin_acc_invoice.issued_at')"
                                :value="$parseDate(invoice.issued_at, 'yyyy-MM-dd')"></v-text-field>
                  <v-text-field readonly
                                hide-details
                                :label="$t('admin_acc_invoice.due_at')"
                                :value="$parseDate(invoice.due_at, 'yyyy-MM-dd')"></v-text-field>
                  <v-text-field readonly
                                hide-details
                                :label="$t('admin_acc_invoice.title')"
                                :value="invoice.title"></v-text-field>
                  <v-text-field readonly
                                hide-details
                                :label="$t('admin_acc_invoice.amount')"
                                :value="parseInt(invoice.amount) / 100.0"></v-text-field>
                  <v-text-field readonly
                                hide-details
                                :label="$t('admin_acc_invoice.status')"
                                :value="$t(`invoice_status.${invoice.status}`)"></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="booking-preview-form-title">
                    <v-col class="pb-0">{{ $t('booking.payment_method') }}</v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pt-0">
                      <v-container>
                        <v-row class="mb-4" v-if="invoice.status === 'AWAITING_PAYMENT'">
                          <v-col cols="12"
                                 :class="['booking-preview-payment-method', 'enabled', {'active': invoice.payment_method === 'cyber_source'}]"
                                 @click="invoice.payment_method = 'cyber_source'">
                            <v-img :src="require('@/assets/logo-credit-cards.png')"></v-img>
                          </v-col>
                          <div :class="['pa-4', 'mt-2', 'mr-2', 'flex-grow-1', 'text-center', 'booking-preview-payment-method', 'enabled', {'active': invoice.payment_method === 'bank_transfer'}]"
                               @click="invoice.payment_method = 'bank_transfer'">
                            {{ $t('payment_method.bank_transfer') }}
                          </div>
                          <div :class="['pa-4', 'mt-2', 'flex-grow-1', 'text-center', 'booking-preview-payment-method', 'enabled', {'active': invoice.payment_method === 'cheque'}]"
                               @click="invoice.payment_method = 'cheque'">
                            {{ $t('payment_method.cheque') }}
                          </div>
                        </v-row>
                        <v-row v-else class="mb-4">
                          <div :class="['pa-4', 'mt-2', 'flex-grow-1', 'text-center', 'booking-preview-payment-method', 'enabled', 'active']">
                            {{ $t(`payment_method.${invoice.payment_method}`) }}
                          </div>
                        </v-row>
                      </v-container>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.payment_method === 'cyber_source'">
                    <v-col>
                      <v-radio-group v-model="selectedPaymentToken">
                        <v-radio v-for="paymentToken in paymentTokens"
                                 :key="paymentToken.id"
                                 :value="paymentToken.id">
                          <template #label>
                            <v-img :src="cardTypeLogo[paymentToken.card_type]"
                                   :max-width="40"
                                   :max-height="30"
                                   class="mr-4"></v-img>
                            {{ `${paymentToken.card_number} (${paymentToken.card_expiry_date})` }}
                          </template>
                        </v-radio>
                        <v-radio :value="false">
                          <template #label>
                            <v-icon class="mr-4">fas fa-plus-square</v-icon>
                            {{ $t('booking_preview.add_payment_token') }}
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <v-row v-if="invoice.payment_method === 'bank_transfer'">
                    <v-col v-html="settings.invoice_bank_transfer_payment_instructions"></v-col>
                  </v-row>
                  <v-row v-if="invoice.payment_method === 'cheque'">
                    <v-col v-html="settings.invoice_cheque_payment_instructions"></v-col>
                  </v-row>
                  <v-row v-if="invoice.payment_method === 'bank_transfer' || invoice.payment_method === 'cheque'">
                    <v-col>
                      <v-input v-model="invoice.payment_proof">
                        <v-container fluid class="flex-column pa-0">
                          <legend class="v-label theme--light">{{ $t('admin_acc_invoice.payment_proof') }}</legend>
                          <PhotoPreviewInput v-model="invoice.payment_proof"
                                             :div-class="invoice.payment_method"
                                             file-name="payment_proof"></PhotoPreviewInput>
                        </v-container>
                      </v-input>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-col>
      </v-row>

      <v-row class="booking-preview-steps  py-2 px-2 py-md-6 px-md-6">
        <v-col :class="$vuetify.breakpoint.width <= 600?'text-center':'text-right'" :cols="$vuetify.breakpoint.width <= 600?6:12">
          <!--CyberSource-->
          <v-btn color="primary" rounded :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2"
                 v-if="invoice.payment_method === 'cyber_source'"
                 @click="payByCreditCard">
            <v-icon>mdi-arrow-right-circle-outline</v-icon>
            <span class="font-size-35">{{ $t('booking.next_step') }}</span>
          </v-btn>
          <v-row :class="['align-end', {'flex-column': $vuetify.breakpoint.width <= 600}]"
                 v-if="invoice.payment_method === 'cyber_source'">
            <v-spacer></v-spacer>
            <v-img max-width="100px" height="50px" contain :src="require('@/assets/visa-secure.jpg')"></v-img>
            <v-img max-width="100px" height="50px" contain :src="require('@/assets/mastercard-securecode.png')"></v-img>
            <v-img max-width="100px" height="50px" contain :src="require('@/assets/jcb-secure.gif')"></v-img>
          </v-row>

          <!--Bank Transfer / Cheque-->
          <v-btn color="primary" rounded :large="$vuetify.breakpoint.width>600"
                 class="ml-2 my-2"
                 v-if="invoice.payment_method === 'bank_transfer' || invoice.payment_method === 'cheque'"
                 :disabled="!invoice.payment_proof"
                 @click="payByOther">
            <v-icon>mdi-arrow-right-circle-outline</v-icon>
            <span class="font-size-35">{{ $t('booking.next_step') }}</span>
          </v-btn>
        </v-col>
      </v-row>

    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {computed, onMounted, ref, watch} from '@vue/composition-api';
import PhotoPreviewInput from "@/components/PhotoPreviewInput.vue";

export default {
  name: 'PayInvoice',
  components: {PhotoPreviewInput, HkiaraceBannerFrame},
  setup(props, {root}) {
    const invoice = ref(null);
    const settings = ref(null);
    const getInvoice = function () {
      root.$callAPI('aafb/invoice/', {invoice_id: root.$route.params.invoiceId}, (response) => {
        invoice.value = response.body.invoice;
        settings.value = response.body.settings;
      })
    }

    const paymentMethod = computed(() => {
      if (invoice.value) {
        return invoice.value.payment_method;
      }
    })
    // Payment Token
    const selectedPaymentToken = ref(false);
    const paymentTokens = ref([]);
    const cardTypeLogo = ref({
      '001': require('@/assets/visa.jpg'),
      '002': require('@/assets/mastercard.png'),
      '007': require('@/assets/jcb.gif'),
    });
    const getPaymentTokens = function () {
      root.$callAPI('payment/cyber_source/payment_tokens/', {}, (response) => {
        paymentTokens.value = response.body.payment_tokens;

        if (paymentTokens.value.length > 0) {
          selectedPaymentToken.value = paymentTokens.value[0].id;
        }
      })
    }
    watch(() => paymentMethod.value, (newValue) => {
      if (newValue === 'cyber_source') {
        getPaymentTokens();
      }
    })

    const postForm = function (path, params, method = 'post') {
      const form = document.createElement('form');
      form.method = method;
      form.action = path;

      for (const key in params) {
        if (params.hasOwnProperty(key)) {
          const hiddenField = document.createElement('input');
          hiddenField.type = 'hidden';
          hiddenField.name = key;
          hiddenField.value = params[key];

          form.appendChild(hiddenField);
        }
      }

      document.body.appendChild(form);
      form.submit();
      root.$startLoading();
    }
    const payByCreditCard = function () {
      if (confirm(root.$t('booking_preview.redirect_warning'))) {
        root.$callAPI('aafb/invoice/init_payment/', {
          invoice_id: invoice.value.id,
          payment_method: invoice.value.payment_method,
          payment_token_id: selectedPaymentToken.value,
        }, function (response) {
          postForm(response.body.url, response.body.params)
        });
      }
    }

    const payByOther = async function () {
      root.$callAPI('aafb/invoice/upload_proof/', {
        invoice_id: invoice.value.id,
        payment_method: invoice.value.payment_method,
        payment_proof: invoice.value.payment_proof instanceof File ? await root.$convertFileToBase64(invoice.value.payment_proof) : invoice.value.payment_proof,
      }, (response) => {
        root.$showAlertMessage(root.$t('invoice.upload_success'));
        root.$router.replace({name: 'my-account', query: {t: 6}})
      })
    }

    onMounted(() => {
      getInvoice();
    })

    return {
      invoice,
      settings,

      selectedPaymentToken,
      paymentTokens,
      cardTypeLogo,

      payByCreditCard,

      payByOther,
    }
  },
}
</script>

<style lang="less">
.booking-preview {
  .booking-preview-banner {
    .booking-preview-banner-label {
      position: absolute;
      left: 50%;
      top: 50%;
      color: white;
      font-size: 3rem;
      text-shadow: 2px 2px rgba(0, 0, 0, 0.25);
      transform: translate(-50%, -50%);
    }
  }

  .booking-preview-content-row {
    background-color: white;

    .booking-preview-form {
      max-width: 1024px;
      margin: auto;

      .v-label {
        color: #8E765B;
      }

      .v-input--is-readonly > .v-input__control > .v-input__slot:before {
        display: none;
      }

      .v-input--is-readonly > .v-input__control > .v-input__slot:after {
        display: none;
      }

      .booking-preview-form-title {
        font-size: 1.5rem;
      }

      .preview-warning-label {
        font-size: .8rem;
      }

      .booking-preview-payment-method {
        border: 2px solid rgba(0, 0, 0, 0.2);

        &.enabled {
          cursor: pointer;

          &:hover, &.active {
            border-color: #8E765B;
          }
        }

        &.pay-by-octopus {
          background: #F3F4F8;

          .pay-by-octopus-wrapper {
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .v-image {
              -webkit-box-flex: 0;
              -ms-flex: 0 0 25%;
              flex: 0 0 25%;
              max-width: 25%;
            }


            .pay-by-octopus-description {
              color: #B3B4B8;
              font-size: 90%;
              text-align: left;
            }
          }
        }
      }
    }
  }

  .booking-preview-steps {
    .v-avatar {
      margin-right: 12px;
    }

    .mdi-arrow-right {
      margin-left: 24px;
      margin-right: 12px;
    }
  }

  .booking-preview-content {
    background-color: #efefef;

    .booking-preview-content-wrapper {
      /*transform: translateY(-120px);*/
      background-color: #efefef;

      .datepicker-calendar {
        width: 100%;
        border: none;
        margin: auto;
      }


    }
  }
}
</style>
